import React, {useState, useEffect} from 'react';
import { acceptTrade, createOrder, cancelTrade, getUserInfo } from '../apiUser'; 
import { isAuthenticated } from '../../auth';
import SuccessModal from '../../core/SuccessModal';

const AcceptCancelTrade = ({trade, setTradeStatus, sendNotification, setSuccessText, handleSuccessOpen}) => {
    const { user: {_id, name}, token } = isAuthenticated();

    const [clickedAccept, setClickedAccept] = useState(false);
    const handleClickAccept = () => setClickedAccept(true);
    const handleClickNo = () => setClickedAccept(false);

    const [clickedCancel, setClickedCancel] = useState(false);
    const handleClickCancel = () => setClickedCancel(true);
    const handleClickCancelNo = () => setClickedCancel(false);
    
    const [recieverShipping, setRecieverShipping] = useState({}) 
    const [senderShipping, setSenderShipping] = useState({}) 


    useEffect(() => {
        getUserInfo(trade.reciever).then(recieverData => {
            setRecieverShipping(recieverData.shipping_address);
        });

        getUserInfo(trade.sender).then(senderData => {
            setSenderShipping(senderData.shipping_address);
        });
    },[]);

    const handleAcceptTrade = () => {
        console.log('_id');
        console.log(_id);
        acceptTrade(_id, trade._id, token).then(data => {
            if (data.error) {
                //TODO; accept trade error handling
                console.log(data.error);
            }
            else {
                setTradeStatus('accepted');

                setSuccessText({
                    title: 'Trade has been accepted!',
                    description: 'Finish up the shipping details in the Orders page',
                    link: '/orders'
                });

                handleSuccessOpen();
                if (trade.reciever === _id) { //if reciever
                    sendNotification('accepted', trade._id,`Trade from ${name} Accepted!`, 
                        'Click to go to orders',``,'/user/orders',
                        _id, trade.sender);
                }
                else { //if sender
                    sendNotification('accepted', trade._id,`Trade from ${name} Accepted!`, 
                        'Click to go to orders',``,'/user/orders',
                        _id, trade.reciever);
                }

                createOrder(_id, trade._id, token, {recieverShipping, senderShipping}).then(data => {
                    //TODO: error handling
                    console.log('ORDER'+data);
                });


            }
        });
    };

    const handleCancelTrade = () => {
        cancelTrade(_id, trade._id, token).then(data => {
            if (data.error) {
                //TODO: decline error handling
            }
            else {
                setTradeStatus('canceled')

                setSuccessText({
                    title: 'Trade has been canceled!',
                    description: 'The trade will remain in your Trades page ',
                    link: '/trades'
                });

                handleSuccessOpen();
            }
        });
    };

    const YouSure = () => (
        <div className="rounded-md bg-green-50 p-4">
            <div className="flex">
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-green-800">Are you sure you want to accept the trade offer?</h3>
                    <div className="mt-4">
                        <div className="-mx-2 -my-1.5 flex">
                            <button
                                onClick={handleAcceptTrade}
                                type="button"
                                className="bg-green-50 px-2 py-1.5 rounded-md text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600"
                            >
                                Yes
                            </button>
                            <button
                                onClick={handleClickNo}
                                type="button"
                                className="ml-3 bg-green-50 px-2 py-1.5 rounded-md text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    const YouSureCancel = () => (
        <div className="rounded-md bg-red-50 p-4">
            <div className="flex">
                <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">Are you sure you want to cancel the trade offer?</h3>
                    <div className="mt-4">
                        <div className="-mx-2 -my-1.5 flex">
                            <button
                                onClick={handleCancelTrade}
                                type="button"
                                className="bg-red-50 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
                            >
                                Yes
                            </button>
                            <button
                                onClick={handleClickCancelNo}
                                type="button"
                                className="ml-3 bg-red-50 px-2 py-1.5 rounded-md text-sm font-medium text-red-800 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-50 focus:ring-red-600"
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


    const Buttons = () => (
        <div className='justify-center'>
            { trade.reciever === _id ? 
                <>
                    <button
                        onClick={handleClickAccept}
                        type="button"
                        className="inline-flex items-center px-2 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-600 hover:bg-green-800 mr-2 mx-auto"
                    >
                        Accept
                    </button>

                    <button
                        onClick={handleClickCancel}
                        type="button"
                        className="inline-flex items-center px-2 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-800 mx-auto"
                    >
                        Cancel
                    </button>
                </>
                :
                <button
                    type="button"
                    className="inline-flex items-center px-2 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-red-600 hover:bg-red-800 mx-auto"
                >
                    Cancel
                </button>

            }

        </div>
    );

    const RenderConditions = () => {
        if (clickedAccept) {
            return ( <YouSure/> );
        }
        else if (clickedCancel) {
            return ( <YouSureCancel/> );
        }
        else {
            return ( <Buttons/> );
        }
    };

    return (
        <>
            <RenderConditions/>
        </>
    );
};

export default AcceptCancelTrade;
